<template>
  <div class="mt-2 flex w-full items-center justify-between md:mt-4">
    <div class="flex flex-col">
      <!-- final price -->
      <span id="final-price" class="order-1 text-4xl font-extrabold">
        {{ formatPrice(displayableFinalPrice) }}
      </span>

      <!-- Base price -->
      <div
        v-if="
          displayableBasePrice > 0 &&
          ((basePrice && basePrice != finalPrice) ||
            (productRecommendedPrice &&
              productRecommendedPrice != productFinalPrice))
        "
        class="order-2 flex items-center gap-1"
      >
        <span v-t="'pages.product_detail_page.price.For'" />
        <span id="base-price" class="line-through">
          {{ formatPrice(displayableBasePrice) }}
        </span>
      </div>
    </div>

    <!-- Discount -->
    <div
      v-if="basePrice && discount > 0"
      class="rounded-xl bg-tertiary px-5 py-2"
    >
      <span id="discount-percentage" class="text-3xl font-extrabold text-white">
        - {{ displayableDiscount }}%
      </span>
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed, ComputedRef } from 'vue';

const props = defineProps({
  basePrice: {
    type: Number,
    required: false,
    default: undefined,
  },

  finalPrice: {
    type: Number,
    required: false,
    default: undefined,
  },
});

const formatPrice = (price: number) => window.hyva.formatPrice(price);
const productFinalPrice: ComputedRef<number> = computed(
  () => window.product_prices.final_price / 100
);
const productRecommendedPrice: ComputedRef<number> = computed(
  () => window.product_prices.base_price / 100
);
const discount: ComputedRef<number> = computed(
  () => window.product_prices.discount / 100
);

const displayableBasePrice: ComputedRef<number> = computed(() => {
  return props.basePrice ?? productRecommendedPrice.value;
});
const displayableFinalPrice: ComputedRef<number> = computed(() => {
  return props.finalPrice ?? productRecommendedPrice.value;
});
const displayableDiscount: ComputedRef<number> = computed(() => {
  return Math.round(
    window.product.discount_price
      ? ((displayableBasePrice.value - displayableFinalPrice.value) /
          displayableBasePrice.value) *
          100
      : discount.value
  );
});
</script>
